import { Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";

const SERIES = [["invitaciones", "Invitaciones", "#0b2a47"], ["registros", "Registros", "#3b82f6"], ["activaciones", "Activaciones", "#bc9538"],
  ["busquedas", "Búsquedas", "#10b981"], ["solicitudes", "Solicitudes", "#dc2626"]];

export const DailyChart = ({ serie }) => (
  <div data-testid="admin-daily-chart" className="c-card p-3 h-72">
    <p className="font-mono text-[10px] tracking-[0.2em] uppercase c-muted mb-2">Últimos 30 días</p>
    <ResponsiveContainer width="100%" height="90%">
      <BarChart data={serie.map((d) => ({ ...d, label: d.dia.slice(5) }))} margin={{ left: -24, right: 4 }}>
        <CartesianGrid strokeDasharray="3 3" opacity={0.25} />
        <XAxis dataKey="label" tick={{ fontSize: 9 }} interval={4} />
        <YAxis allowDecimals={false} tick={{ fontSize: 10 }} />
        <Tooltip />
        <Legend wrapperStyle={{ fontSize: 10 }} />
        {SERIES.map(([k, n, c]) => <Bar key={k} dataKey={k} name={n} stackId="a" fill={c} />)}
      </BarChart>
    </ResponsiveContainer>
  </div>
);
